import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { willAutoBackup as willAutoBackupActions } from "actions";

import TemplateStep1 from "Components/Templates/Step1";

export default function PageStep1() {
   const navigate = useNavigate();
   const dispatch = useDispatch();

   function nextOnClick() {
      dispatch({
         type: willAutoBackupActions.setOn,
      });
      navigate("/steps/2");
   }
   return (
      <>
         <TemplateStep1 nextOnClick={nextOnClick}></TemplateStep1>
      </>
   );
}
